import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { ExportRequestContextType } from '../types/context.types';

const ExportRequestContext = createContext<ExportRequestContextType | undefined>(undefined);

export const useExportRequest = () => {
  const context = useContext(ExportRequestContext);
  if (!context) throw new Error('useExportRequest must be used within ExportProvider.');
  return context;
};

export const ExportRequestProvider = ({
  children,
  value
}: {
  children: ReactNode;
  value: ExportRequestContextType;
}) => {
  return <ExportRequestContext.Provider value={value}>{children}</ExportRequestContext.Provider>;
};
